module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":"This website uses cookies to improve websites, services and advertising.","decline":"Decline","privacyPolicy":"Check Privacy Policy","checked":"Got it!"},"ja":{"message":"このサイトでは、サイト・サービス・広告を改善するためにCookieを利用します。","decline":"拒否する","privacyPolicy":"プライバシーポリシーを確認","checked":"確認した"}}')
  delete Component.options._Ctor
}
